import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { IClientPaymentMethod } from '../types';

export const filterMethodById =
  (methodId: PaymentMethod) => (method: IClientPaymentMethod) =>
    method.value === methodId;
